import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OtherExpencesEditPage } from './other-expences-edit.page';

const routes: Routes = [
  {
    path: '',
    component: OtherExpencesEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OtherExpencesEditPageRoutingModule {}
